import { connect } from "react-redux";
import React, { useState } from "react";
import TimesheetRow from "./TimesheetRow";
import { CalendarIcon, ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/20/solid";
import Spinner from "../common/Spinner";
import { Actions as ACTIONS } from "../../store/actions/timesheetActions";

const EmployeeTimesheet = ({ employeeTimesheet, salary, approveTimesheets, userPermissions, location }) => {
	const [expand, setExpand] = useState(true);
	const [approving, setApproving] = useState(false);

	const pendingTimesheets = employeeTimesheet.timesheets.filter((t) => t.status && ["Pending"].includes(t.status));

	return [
		<tr
			key={employeeTimesheet.employeeId}
			className={
				salary?.employmentType === 501
					? "employmentType-FT"
					: salary?.employmentType
						? "employmentType-PT"
						: "employmentType-C"
			}
		>
			<td>
				<div>
					<a
						onClick={() => {
							setExpand(!expand);
						}}
						className="btn btn-xs btn-default"
						type="button"
					>
						{expand ? (
							<ChevronUpIcon style={{ height: "1.75em", float: "left" }} />
						) : (
							<ChevronDownIcon style={{ height: "1.75em", float: "left" }} />
						)}
					</a>
				</div>
			</td>
			{location == "timesheetPage" && (
				<td>
					{employeeTimesheet?.employee?.employeeDetails?.givenName}{" "}
					{employeeTimesheet?.employee?.employeeDetails?.familyName}
				</td>
			)}
			<td>
				{salary?.employmentType == 501
					? "Full-Time"
					: salary?.employmentType == 502
						? "Part-Time"
						: "External Contractor"}
			</td>
			<td>
				{parseFloat(employeeTimesheet.total).toFixed(2)}
				{parseFloat(employeeTimesheet.total) !== employeeTimesheet.paid &&
					` (${employeeTimesheet?.unpaid?.toFixed(2)} unpaid)`}
			</td>
			<td colSpan={4}></td>
			<td>
				{userPermissions != "Read" && pendingTimesheets && pendingTimesheets.length > 0 ? (
					<div
						style={{ marginRight: "5px" }}
						className="btn btn-xs btn-success"
						title="Approve All"
						onClick={() => {
							setApproving(true);
							approveTimesheets(pendingTimesheets, setApproving);
						}}
					>
						{approving ? (
							<Spinner
								style={{ height: "1.5em", verticalAlign: "middle", float: "left" }}
								className="animate-spin -ml-1 mr-3 h-5 w-5 "
							/>
						) : (
							<CalendarIcon
								style={{
									height: "1.5em",
									float: "left",
									marginRight: 5,
								}}
							/>
						)}
						<div style={{ float: "left" }}>Approve All</div>
					</div>
				) : (
					<></>
				)}
			</td>
		</tr>,
		expand &&
			employeeTimesheet?.timesheets?.map((timesheet) => (
				<TimesheetRow
					key={timesheet.id}
					salary={salary}
					timesheet={timesheet}
				/>
			)),
	];
};

const mapStateToProps = (state) => {
	const userPermissions = state?.permissions?.my?.permissions?.timesheets;

	return {
		userPermissions,
	};
};

const mapDispatchToProps = (dispatch) => ({
	approveTimesheets: (timesheets, callback) => dispatch(ACTIONS.approveTimesheets(timesheets, callback)),
});
export default connect(mapStateToProps, mapDispatchToProps)(EmployeeTimesheet);
